import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/packinglists',
    name: 'packinglists',
    component: () => import( /* webpackChunkName: "packingLists" */ './views/PackingLists.vue')
  },
  {
    path: '/pccpcicards',
    name: 'pccpcicards',
    component: () => import(/* webpackChunkName: "pccPciCards" */ './views/PccPciCards.vue')
  },
  {
    path: '/tiedowns',
    name: 'tiedowns',
    component: () => import(/* webpackChunkName: "tieDowns" */ './views/TieDowns.vue')
  },
  {
    path: '/physicalreadiness',
    name: 'physicalreadiness',
    component: () => import(/* webpackChunkName: "physicalReadiness" */ './views/PhysicalReadiness.vue')
  },
  {
    path: '/footmarches',
    name: 'conditioning',
    component: () => import(/* webpackChunkName: "footMarches" */ './views/FootMarches.vue')
  },
  {
    path: '/fitnesstest',
    name: 'fitnesstest',
    component: () => import(/* webpackChunkName: "fitnessTest" */ './views/FitnessTest.vue')
  },
  {
    path: '/warnord',
    name: 'warnord',
    component: () => import(/* webpackChunkName: "warnord" */ './views/Warnord.vue')
  },
  {
    path: '/conop',
    name: 'conop',
    component: () => import(/* webpackChunkName: "conop" */ './views/Conop.vue')
  },
  {
    path: '/opord',
    name: 'opord',
    component: () => import(/* webpackChunkName: "opord" */ './views/Opord.vue')
  },
  {
    path: '/fragord',
    name: 'fragord',
    component: () => import(/* webpackChunkName: "fragord" */ './views/Fragord.vue')
  },
  {
    path: '/terrain',
    name: 'terrain',
    component: () => import(/* webpackChunkName: "terrainModelStandards" */ './views/TerrainModelStandards.vue')
  },
  {
    path: '/rxls',
    name: 'rxls',
    component: () => import(/* webpackChunkName: "rxls" */ './views/Rxls.vue')
  },
  {
    path: '/accountability',
    name: 'accountability',
    component: () => import(/* webpackChunkName: "accountability" */ './views/Accountability.vue')
  },
  {
    path: '/movement',
    name: 'movement',
    component: () => import(/* webpackChunkName: "movement" */ './views/Movement.vue')
  },
  {
    path: '/formations',
    name: 'formations',
    component: () => import(/* webpackChunkName: "formations" */ './views/Formations.vue')
  },
  {
    path: '/actions',
    name: 'actions',
    component: () => import(/* webpackChunkName: "actions" */ './views/Actions.vue')
  },
  {
    path: '/patrol',
    name: 'patrol',
    component: () => import(/* webpackChunkName: "patrol" */ './views/Patrol.vue')
  },
  {
    path: '/battleroster',
    name: 'battleroster',
    component: () => import(/* webpackChunkName: "battelRoster" */ './views/BattleRoster.vue')
  },
  {
    path: '/casevac',
    name: 'casevac',
    component: () => import(/* webpackChunkName: "casevac" */ './views/Casevac.vue')
  },
  {
    path: '/medops',
    name: 'medops',
    component: () => import(/* webpackChunkName: "medOps" */ './views/MedOps.vue')
  },
  {
    path: '/logpac',
    name: 'logpac',
    component: () => import(/* webpackChunkName: "logpac" */ './views/Logpac.vue')
  },
  {
    path: '/recurringreports',
    name: 'recurringreports',
    component: () => import(/* webpackChunkName: "recurringReports" */ './views/RecurringReports.vue')
  },
  {
    path: '/sensitivereports',
    name: 'sensitivereports',
    component: () => import(/* webpackChunkName: "sensitiveReports" */ './views/SensitiveReports.vue')
  },
  {
    path: '/aar',
    name: 'aar',
    component: () => import(/* webpackChunkName: "aar" */ './views/AAR.vue')
  },
  {
    path: '/riskmanagement',
    name: 'riskmanagement',
    component: () => import(/* webpackChunkName: "riskManagement" */ './views/RiskManagement.vue')
  },
  {
    path: '/heat',
    name: 'heat',
    component: () => import(/* webpackChunkName: "heat" */ './views/Heat.vue')
  },
  {
    path: '/fieldhygiene',
    name: 'fieldhygiene',
    component: () => import(/* webpackChunkName: "fieldhygiene" */ './views/FieldHygiene.vue')
  },
  {
    path: '/rangeops',
    name: 'rangeops',
    component: () => import(/* webpackChunkName: "rangeOps" */ './views/RangeOps.vue')
  },
  {
    path: '/weaponsafetydoc',
    name: 'weaponsafetydoc',
    component: () => import(/* webpackChunkName: "weaponSafetyDoc" */ './views/WeaponSafetyDoc.vue')
  },
  {
    path: '/weaponclearing',
    name: 'weaponclearing',
    component: () => import(/* webpackChunkName: "weaponClearing" */ './views/WeaponClearing.vue')
  },
  ]
})